<template>
  <div>
    <b-col
      cols="12"
      class="h5 text-azul-medio font-weight-normal px-0 text-center text-lg-left gilmer"
      >UBICACIÓN Y CONTACTOS</b-col
    >
    <div class="rounded border border-violeta-claro p-3 h6">
      <b-row class="border-bottom border-azul-oscuro mb-0 pb-1">
        <b-col cols="12" class="row mb-2">
          <b-col cols="4" class="text-right pr-1 text-morado-claro"
            >Dirección</b-col
          >
          <b-col cols="8"
            ><a
              @click="
                $gtag.event('ver-direccion-establecimiento', {
                  event_category: 'direccion-establecimiento',
                  event_label: 'ver-direccion-establecimiento',
                  value: ''
                })
              "
              :href="googleMapsUrl"
              target="_blank"
              class="font-weight-bold text-morado-claro font-weight-bold"
              ><u>{{ direccion }}</u
              ><FontAwesomeIcon icon="map-marker-alt" class="ml-2"/></a
          ></b-col>
        </b-col>
        <b-col cols="12" class="row mb-2">
          <div class="col-4 text-right pr-1 text-morado-claro">Región</div>
          <div class="col-8">
            <span class="font-weight-bold text-morado-claro">{{ region }}</span>
          </div>
        </b-col>
        <b-col cols="12" class="row mb-2">
          <b-col cols="4" class="text-right pr-1 text-morado-claro"
            >Comuna</b-col
          >
          <b-col cols="8"
            ><span class="font-weight-bold text-morado-claro">{{
              comuna
            }}</span></b-col
          >
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col cols="12" lg class="col-print-4">
          <dl class="row pb-0 mb-3 mb-lg-0">
            <dt class="col-4 h5 text-black-50 pt-1 text-right d-print-none">
              <FontAwesomeIcon icon="phone" class="mr-1" />
            </dt>
            <a :href="'tel:' + telefono">
              <dd class="col-8 text-morado-claro pb-0 mb-0 pl-1 ">
                Teléfono
                <div class="font-weight-bold text-morado-claro d-block">
                  {{ telefono }}
                </div>
              </dd>
            </a>
          </dl>
        </b-col>
        <b-col cols="12" lg="7" class="col-print-8">
          <dl class="row pb-0 mb-0">
            <dt class="col-4 h5 text-black-50 pt-1 text-right d-print-none">
              <FontAwesomeIcon icon="laptop" class="mr-1" />
            </dt>
            <dd class="col-8 pb-0 mb-0 pl-1 text-morado-claro">
              Página web
              <a
                v-if="paginaWeb !== 'Sin información'"
                @click="
                  $gtag.event('ver-pagina-web-establecimiento', {
                    event_category: 'pagina-web-establecimiento',
                    event_label: 'ver-pagina-web-establecimiento',
                    value: ''
                  })
                "
                :href="'http://' + paginaWeb"
                target="_blank"
                class="font-weight-bold text-morado-claro d-block text-truncate"
                ><u>{{ paginaWeb }}</u></a
              >
              <div class="font-weight-bold text-morado-claro d-block" v-else>
                {{ paginaWeb }}
              </div>
            </dd>
          </dl>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faMapMarkerAlt,
  faLaptop,
  faPhone
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faMapMarkerAlt, faLaptop, faPhone);
export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    direccion: {
      type: String,
      required: true
    },
    region: {
      type: String,
      required: true
    },
    comuna: {
      type: String,
      required: true
    },
    telefono: {
      type: String,
      required: true
    },
    paginaWeb: {
      type: String,
      required: true
    },
    coordenadas: {
      type: Array,
      required: true
    }
  },
  computed: {
    //calcula url de google maps segun coordenadas
    googleMapsUrl() {
      return (
        "https://www.google.com/maps/place/" +
        this.coordenadas[1] +
        "," +
        this.coordenadas[0]
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/derecha/DatosSede.vue